import React from "react";

/**
 * The onboarding illustration and the white fade that blends its foot into the
 * page.
 *
 * Renders into a positioned container the caller supplies — an
 * `absolute inset-0 overflow-hidden` layer spanning the whole column. The
 * picture is a backdrop, not a row: the copy, the dots and the buttons all sit
 * on top of its lower half, where the fade has taken it to white.
 *
 * `object-cover object-top`, so the picture actually reaches the full height of
 * the layer. Contain would not: the artwork is 459x783, proportionally wider
 * than a phone viewport, so containing it makes the width the binding
 * constraint and it stops around three quarters of the way down with dead
 * space beneath.
 *
 * Cover crops, but on a tall layer it crops the sides, and the illustration
 * carries roughly 70px of empty white margin either side of the icon bubbles —
 * so there is nothing there to lose. (On a short layer cover crops vertically
 * instead and shows only the top of the phone, which is why this was contain
 * while the artwork was still a row rather than a backdrop.)
 *
 * The fade replaces a fixed 393x647 SVG pinned 213px from the top — an offset
 * that agreed with exactly one container height. As a gradient it holds its
 * proportions at any size: clear over the phone, and solid white by the time
 * the copy starts, so the text always has something plain to sit on.
 */
const OnboardingArtwork = ({ src, alt }) => (
  <>
    <img
      src={src}
      alt={alt}
      className="w-full h-full object-contain object-top"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 bottom-0 h-3/5"
      style={{
        background:
          "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 35%, #fff 58%)",
      }}
    />
  </>
);

export default OnboardingArtwork;
